
import React, { useState,useEffect, useCallback, useContext } from "react";
import api from "../../services/api";

import { makeStyles } from 'tss-react/mui';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles()(theme => ({
    chips: {
        display: "flex",
        flexWrap: "wrap",
    },
    chip: {
        margin: 2,
    },
    selectContainer: {
        width: "100%",
        textAlign: "left",
    },
}));

const Conections = ({ value , onChange }) => {
    const { classes } = useStyles();
    const { whatsApps, loading } = useContext(WhatsAppsContext);
    const { user } = useContext(AuthContext);

    const myQueueIds = (user?.queues || []).map(queue => queue.id);

    const availableConnections = (whatsApps || []).filter(items => {
        const isConnected = items.status == "CONNECTED" && (items.channel == "whatsapp" || items.channel == "whatsapp_cloud");
        const isAnchoredToMyQueues = (items.queues || []).some(queue => myQueueIds.includes(queue.id));
        return isConnected && isAnchoredToMyQueues;
    });

    useEffect(() => {
        if (!loading && !value && availableConnections.length === 1) {
            onChange(availableConnections[0].id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, availableConnections.length, value]);

    const handleChangeConection = e => {
		onChange(e.target.value);
	};
    return (

            <FormControl  className={classes.selectContainer}>
                <Select
                	fullWidth
                    displayEmpty
                    variant="outlined"
                    value={value}
                    MenuProps={{
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                        getContentAnchorEl: null,
                    }}
                    onChange={handleChangeConection}
                >
                    <MenuItem key='' value=''>
                        Conexion por defecto
                    </MenuItem>

                    {availableConnections.map(items => (
                        <MenuItem key={items.id} value={items.id}>
                            {items.name}
                        </MenuItem>
                    ))}

                </Select>



            </FormControl>

    );
};





export default Conections;
